import PropTypes from 'prop-types';
import { isArray } from 'lodash/fp';
import { Trans, useTranslation } from 'react-i18next';
import { DisplayErrorsPropType } from 'app/lib/proptypes';
import { Banner } from 'app/components/core/Banner';
import { errorToI18n, isRegularError, unwrapErrors } from 'app/lib/error';
import * as styles from './ErrorBanner.css';
import { getBannerVariantFromErrorLevel } from './utils';

const DEFAULT_FN = errorToI18n();

export function ErrorBanner({ error, mapToI18n = DEFAULT_FN, ...props }) {
    const { t } = useTranslation();

    let translatedErrorOrErrors;
    if (isRegularError(error)) {
        const translateError = (error) => {
            const i18nError = mapToI18n(error);

            if (i18nError.components) {
                return {
                    trans: (
                        <Trans
                            i18nKey={i18nError.key}
                            ns={i18nError.data.ns}
                            values={i18nError.data}
                            components={i18nError.components}
                        />
                    ),
                    key: i18nError.key
                };
            }

            return { trans: t(i18nError.key, i18nError.data), key: i18nError.key };
        };

        const errorOrErrors = unwrapErrors(error);
        translatedErrorOrErrors = isArray(errorOrErrors)
            ? errorOrErrors.map(translateError)
            : translateError(errorOrErrors);
    } else {
        translatedErrorOrErrors = { trans: error };
    }

    if (isArray(translatedErrorOrErrors)) {
        return (
            <div className={styles.translatedError}>
                {translatedErrorOrErrors.map((errorMessage, index) => (
                    <Banner
                        variant={getBannerVariantFromErrorLevel(error?.level)}
                        // There is no unique identifier, so resort to using index
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        {...props}>
                        {errorMessage.trans}
                    </Banner>
                ))}
            </div>
        );
    }

    return (
        <Banner variant={getBannerVariantFromErrorLevel(error?.level)} {...props}>
            {translatedErrorOrErrors.trans}
        </Banner>
    );
}

ErrorBanner.propTypes = {
    error: DisplayErrorsPropType.isRequired,
    mapToI18n: PropTypes.func
};
